<template>
  <el-card>
    <el-row>
      <el-col :span="18">&nbsp;</el-col>
      <el-col :span="6">
        <el-button v-if="showAdd" type="primary" @click="addCompany">添加保险公司</el-button>
        <el-button v-if="showAdd" type="primary" @click="openSpecialCommissionDialog">特殊佣金设置</el-button>
      </el-col>
    </el-row>

    <el-row>
      <el-col>

        <el-table
          :data="list"
          style="width: 100%">
          <el-table-column
            prop="id"
            label="id">
            <template slot-scope="scope" >
              {{scope.row.id}}
            </template>
          </el-table-column> 

          <el-table-column
            prop="company_name"
            label="公司名称">
            <template slot-scope="scope" >
              {{scope.row.company_name}}
            </template>
          </el-table-column> 

          <el-table-column
            prop="company_short_name"
            label="公司简称">
            <template slot-scope="scope" >
              {{scope.row.company_short_name}}
            </template>
          </el-table-column> 

          <el-table-column
            prop="company_code"
            label="公司代码">
          </el-table-column> 

          <el-table-column
            prop="remark"
            label="备注">
          </el-table-column> 

          <el-table-column
            prop="create_time"
            label="创建时间">
            <template slot-scope="scope">
              <span>{{scope.row.create_time | parseTime('{y}-{m}-{d}')}}</span>
            </template>
          </el-table-column> 

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" content="查看">
                <el-button v-if="showView" type="text" @click="viewCompany(scope.row.id)">
                  <i class="el-icon-view"></i>
                </el-button>
              </el-tooltip>

              <el-tooltip effect="light" placement="top-start" content="编辑">
                <el-button v-if="showEdit" type="text" @click="editCompany(scope.row.id)">
                  <i class="el-icon-edit"></i>
                </el-button>
              </el-tooltip>

              <!-- <el-tooltip effect="light" placement="top-start" content="删除">
                <el-button v-if="showDelete" type="text" @click="deleteCompany(scope.row.id)">
                  <i class="el-icon-delete"></i>
                </el-button>
              </el-tooltip> -->

              <el-tooltip effect="light" placement="top-start" content="子公司管理">
+                <el-button v-if="showManageBranchOffice" type="text" @click="manageBranchOffice(scope.row.id)">                
                  <i class="el-icon-s-cooperation"></i>
                </el-button>
              </el-tooltip>

              <el-tooltip effect="light" placement="top-start" content="查看险种费率列表">
                <el-button v-if="showInsuranceTypeCommissionRateList" type="text" @click="viewInsuranceTypeCommisionRateList(scope.row.id)">
                  <i class="el-icon-s-fold"></i>
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column> 

        </el-table>
        <pagination ref="pagination" :size.sync="query.limit" :offset.sync="query.offset" :total="total" @updateList="getList"></pagination>
      </el-col>
    </el-row>
    <el-dialog 
      :visible.sync="showInsuranceTypeCommissionRateDialog">
      <el-table :data="insuranceTypeCommissionRateList" width=100%>
        <el-table-column
          prop="company_name"
          label="保险公司">
          <template slot-scope="scope" >
            {{scope.row.company_name}}
          </template>
        </el-table-column> 
        <el-table-column
          prop="type_name"
          label="险种名称">
          <template slot-scope="scope" >
            {{scope.row.type_name}}
          </template>
        </el-table-column> 
        <el-table-column
          prop="commission_rate"
          label="手续费">
          <template slot-scope="scope" >
            {{scope.row.commission_rate}}
          </template>
        </el-table-column> 
        <el-table-column
          prop="remark"
          label="备注">
          <template slot-scope="scope" >
            {{scope.row.remark}}
          </template>
        </el-table-column> 
      </el-table>
    </el-dialog>

    <!-- 特殊佣金设置列表对话框 -->
    <el-dialog 
      :visible.sync="showSpecialCommissionDialog" 
      title="特殊佣金设置"
      width="90%"
      top="20px">
      <el-row style="margin-bottom: 10px;">
        <el-col :span="22">&nbsp;</el-col>
        <el-col :span="2">
          <el-button type="primary" @click="addSpecialCommission">添加</el-button>
        </el-col>
      </el-row>
      <el-row style="height: 400px; overflow-y: auto;">
        <el-col>
          <el-table :data="specialCommissionList" width="100%">
            <el-table-column prop="name" label="方案名称"></el-table-column>
            <el-table-column prop="commission_2agent_rate" label="佣金比例">
              <template slot-scope="scope">{{scope.row.commission_2agent_rate}}%</template>
            </el-table-column>
            <el-table-column prop="is_active" label="启用状态">
              <template slot-scope="scope">
                <el-switch :value="scope.row.is_active" disabled></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="condition_count" label="条件数量">
              <template slot-scope="scope">
                {{(scope.row.rules || []).length}}
              </template>
            </el-table-column>
            <!-- <el-table-column prop="remark" label="备注">
              <template slot-scope="scope">
                {{scope.row.remark || '-'}}
              </template>
            </el-table-column> -->
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="editSpecialCommission(scope.row.id)">修改</el-button>
                <el-button type="text" @click="copySpecialCommission(scope.row)">复制</el-button>
                <el-button type="text" @click="deleteSpecialCommissionItem(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px;">
        <pagination 
          ref="specialCommissionPagination" 
          :size.sync="specialCommissionQuery.limit" 
          :offset.sync="specialCommissionQuery.offset" 
          :total="specialCommissionTotal" 
          @updateList="getSpecialCommissionList">
        </pagination>
      </el-row>
    </el-dialog>

    <!-- 特殊佣金设置明细对话框 -->
    <el-dialog 
      :visible.sync="showSpecialCommissionDetailDialog" 
      :title="specialCommissionDetailTitle"
      width="90%">
      <el-form ref="specialCommissionForm" :model="specialCommissionForm" :rules="specialCommissionRules">
        <el-form-item label="方案名称" prop="name">
          <el-input v-model="specialCommissionForm.name" placeholder="请输入方案名称"></el-input>
        </el-form-item>
        <el-form-item label="启用状态" prop="is_enabled">
          <el-switch v-model="specialCommissionForm.is_enabled"></el-switch>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="specialCommissionForm.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
        
        <el-divider content-position="left">基础条件（适用范围）</el-divider>
        <el-form-item label="基础条件说明">
          <span style="color:#666">设置该方案适用的基础条件，如被保险人范围、保险公司范围等</span>
        </el-form-item>
        <el-form-item>
          <el-button type="text" @click="addBaseCondition">添加基础条件</el-button>
          <el-table :data="specialCommissionForm.base_conditions" width="100%">
            <el-table-column label="条件类型">
              <template slot-scope="scope">
                <el-select v-model="scope.row.condition_type" placeholder="请选择条件类型">
                  <el-option label="保险公司" value="insurance_company_branch_office"></el-option>
                  <el-option label="被保险人" value="insured"></el-option>
                  <el-option label="投保人" value="applicant"></el-option>
                  <el-option label="险种" value="insurance_type"></el-option>
                  <el-option label="船名" value="ship_name"></el-option>
                  <el-option label="其他" value="other"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="自定义条件项名称" v-if="hasOtherConditionType">
              <template slot-scope="scope">
                <el-input v-if="scope.row.condition_type === 'other'" v-model="scope.row.custom_condition_name" placeholder="请输入自定义条件项名称"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作符">
              <template slot-scope="scope">
                <el-select v-model="scope.row.operator" placeholder="请选择操作符">
                  <el-option label="等于" value="eq"></el-option>
                  <el-option label="不等于" value="ne"></el-option>
                  <el-option label="包含" value="contains"></el-option>
                  <el-option label="不包含" value="not_contains"></el-option>
                  <el-option label="在列表中" value="in_list"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="条件值">
              <template slot-scope="scope">
                <el-input v-model="scope.row.value" placeholder="请输入条件值，多个值用逗号或逻辑符（如：&、|）分隔"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="removeBaseCondition(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        
        <el-divider content-position="left">佣金比例设置</el-divider>
        <el-form-item label="佣金比例(%)">
          <el-input v-model="specialCommissionForm.commission_2agent_rate" type="number" placeholder="请输入佣金比例"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeSpecialCommissionDetailDialog">取消</el-button>
        <el-button type="primary" @click="saveSpecialCommission">保存</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import Pagination from '@/components/Pagination'
import { fetchSettingCompanyList } from '@/api/billing'
import { deleteSettingCompany } from '@/api/billing'
import { fetchInsuranceTypeCommissionRateList } from '@/api/billing'
import { fetchSpecialCommissionList, createSpecialCommission, updateSpecialCommission, deleteSpecialCommission, fetchSpecialCommission } from '@/api/billing'
import { parseTime } from '@/utils'
export default {
  name: 'setting-company-list',
  components: {
    Pagination
  },
  data() {
    return {
      showView: false,
      showAdd: false,
      showEdit: false,
      showDelete: false,
      showManageBranchOffice: false,
      showInsuranceTypeCommissionRateList: false,
      showInsuranceTypeCommissionRateDialog: false,
      insuranceTypeCommissionRateList: [],
      // 特殊佣金相关
      showSpecialCommissionDialog: false,
      showSpecialCommissionDetailDialog: false,
      specialCommissionDetailTitle: '添加特殊佣金方案',
      specialCommissionList: [],
      specialCommissionTotal: 0,
      specialCommissionQuery: {
        offset: 0,
        limit: 20
      },
      specialCommissionFormId: null,
      specialCommissionForm: {
        name: '',
        is_enabled: true,
        remark: '',
        base_conditions: [],
        commission_2agent_rate: ''
      },
      specialCommissionRules: {
        name: [
          { required: true, message: '请输入方案名称', trigger: 'blur' }
        ]
      },
      query: {
        offset: 0,
        limit: 20
      },
      total: 0,
      loading: false,
      list: []
    }
  },
  computed: {
    hasOtherConditionType: function() {
      return this.specialCommissionForm.base_conditions.some(c => c.condition_type === 'other')
    }
  },
  methods: {
    addCompany: function(){
      console.log('addCompany()')
      this.$router.push({name: 'addSettingCompany'})
    },
    viewCompany: function(id){
      console.log('viewCompany(): id=' + id )
      this.$router.push({name: 'viewSettingCompany', query: {id: id}})
    },
    editCompany: function(id){
      console.log('editCompany(): id=' + id )
      this.$router.push({name: 'editSettingCompany', query: {id: id}})
    },
    deleteCompany: function(id){
      console.log('deleteCompany(): id=' + id )
      deleteSettingCompany(id)
        .then(res=>{
          setTimeout(()=>{
            this.$message.success('成功删除公司信息')
            this.getList()
          }, 500)
        }).catch(err=>{
          this.$error_message(err)
        })
    },
    manageBranchOffice: function(id){
      console.log('manageBranchOffice()')
      this.$router.push({name: 'settingCompanyBranchOfficeList', query: {company_id:id}})
    },
    viewInsuranceTypeCommisionRateList: function(id) {
      this.showInsuranceTypeCommissionRateDialog = true
      fetchInsuranceTypeCommissionRateList(id)
        .then(resp => {
          this.insuranceTypeCommissionRateList = resp
        }).catch(err =>{
          this.$error_message('获取险种类型手续费比例列表失败')
        })
    },
    // 特殊佣金设置相关方法
    openSpecialCommissionDialog: function() {
      this.showSpecialCommissionDialog = true
      this.getSpecialCommissionList()
    },
    getSpecialCommissionList: function() {
      fetchSpecialCommissionList(this.specialCommissionQuery)
        .then(resp => {
          this.specialCommissionList = resp.results || resp
          this.specialCommissionTotal = resp.count || this.specialCommissionList.length
        }).catch(err => {
          this.$error_message('获取特殊佣金列表失败')
        })
    },
    addSpecialCommission: function() {
      this.specialCommissionDetailTitle = '添加特殊佣金方案'
      this.specialCommissionFormId = null
      this.specialCommissionForm = {
        name: '',
        is_enabled: true,
        remark: '',
        base_conditions: [],
        commission_2agent_rate: ''
      }
      this.showSpecialCommissionDetailDialog = true
    },
    editSpecialCommission: function(id) {
      this.specialCommissionDetailTitle = '修改特殊佣金方案'
      this.specialCommissionFormId = id
      fetchSpecialCommission(id)
        .then(resp => {
          this.specialCommissionForm = {
            name: resp.name,
            is_enabled: resp.is_active,
            remark: resp.remark || '',
            base_conditions: (resp.rules || []).map(rule => ({
              condition_type: rule.condition_type,
              operator: rule.operator,
              value: rule.value,
              custom_condition_name: rule.custom_condition_name || ''
            })),
            commission_2agent_rate: resp.commission_2agent_rate || ''
          }
          this.showSpecialCommissionDetailDialog = true
        }).catch(err => {
          this.$error_message('获取特殊佣金方案详情失败')
        })
    },
    deleteSpecialCommissionItem: function(id) {
      this.$confirm('确定要删除该特殊佣金方案吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteSpecialCommission(id)
          .then(resp => {
            this.$message.success('删除成功')
            this.getSpecialCommissionList()
          }).catch(err => {
            this.$error_message('删除失败')
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    copySpecialCommission: function(row) {
      this.specialCommissionDetailTitle = '复制特殊佣金方案'
      this.specialCommissionFormId = null
      this.specialCommissionForm = {
        name: row.name + '（复制）',
        is_enabled: false,
        remark: row.remark || '',
        base_conditions: (row.rules || []).map(rule => ({
          condition_type: rule.condition_type,
          operator: rule.operator,
          value: rule.value,
          custom_condition_name: rule.custom_condition_name || ''
        })),
        commission_2agent_rate: row.commission_2agent_rate || ''
      }
      this.showSpecialCommissionDetailDialog = true
    },
    // 基础条件操作
    addBaseCondition: function() {
      this.specialCommissionForm.base_conditions.push({
        condition_type: '',
        operator: '',
        value: '',
        custom_condition_name: ''
      })
    },
    removeBaseCondition: function(index) {
      this.specialCommissionForm.base_conditions.splice(index, 1)
    },
    saveSpecialCommission: function() {
      this.$refs.specialCommissionForm.validate((valid) => {
        if (valid) {
          const rules = this.specialCommissionForm.base_conditions
            .filter(c => c.condition_type && c.operator && c.value)
            .map(c => {
              const rule = {
                condition_type: c.condition_type,
                operator: c.operator,
                value: c.value
              }
              if (c.condition_type === 'other' && c.custom_condition_name) {
                rule.custom_condition_name = c.custom_condition_name
              }
              return rule
            })
          
          const data = {
            name: this.specialCommissionForm.name,
            is_active: this.specialCommissionForm.is_enabled,
            remark: this.specialCommissionForm.remark,
            rules: rules,
            commission_2agent_rate: parseFloat(this.specialCommissionForm.commission_2agent_rate) || null
          }
          if (this.specialCommissionFormId) {
            updateSpecialCommission(data, this.specialCommissionFormId)
              .then(resp => {
                this.$message.success('修改成功')
                this.closeSpecialCommissionDetailDialog()
                this.getSpecialCommissionList()
              }).catch(err => {
                this.$error_message('修改失败')
              })
          } else {
            createSpecialCommission(data)
              .then(resp => {
                this.$message.success('添加成功')
                this.closeSpecialCommissionDetailDialog()
                this.getSpecialCommissionList()
              }).catch(err => {
                this.$error_message('添加失败')
              })
          }
        }
      })
    },
    closeSpecialCommissionDetailDialog: function() {
      this.showSpecialCommissionDetailDialog = false
      this.specialCommissionFormId = null
      this.specialCommissionForm = {
        name: '',
        is_enabled: true,
        remark: '',
        base_conditions: [],
        commission_2agent_rate: ''
      }
    },
    getList: function(){
      this.loading = true
      fetchSettingCompanyList(this.query)
        .then( res => {
          this.list = res.results
          this.total = res.count
          this.loading = false
        }).catch( err => {
          console.log("error:  ")
          console.log(err)          
          this.loading = false
          this.$error_message(err)          
        })
    }
  },
  created() {
    // 权限检查
    if (!this.$perm(["billing.list_setting_company"])) {
      this.$router.push('/401')
    }
    this.showView = true

    if (this.$perm(["billing.create_setting_company"])) {
      this.showAdd = true
    }

    if (this.$perm(["billing.update_setting_company"])) {
      this.showEdit = true
    }

    if (this.$perm(["billing.delete_setting_company"])) {
      this.showDelete = true
    }

    if (this.$perm(["billing.list_setting_branch_office"])) {
      this.showManageBranchOffice = true      
    }

    this.getList()
  }
}
</script>